export default __webpack_public_path__ + "static/media/recorte_2.b0ce1358.JPG";